import React from 'react';
import ServicePage from '../../components/site/ServicePage';
import { SALES_FAQS as FAQS } from '../../site/faqs';
import { CONTACT } from '../../site/nav';

export default function SalesAssistant() {
  return (
    <ServicePage
      path="/sales-assistant"
      eyebrow="In-store sales assistant"
      title="Every variable in. The right pieces out. The customer leaves with them."
      lead="Your salesperson enters what the customer needs. The assistant searches a catalog of many brands and shares the results live to the customer’s own portal in the store. They leave with it on their phone."
      proof={{ label: 'See it live on eastbay.direct', href: CONTACT.liveSite }}
      features={[
        { title: 'Every variable', text: 'Room, piece, wall width and depth, colour, material, seats, bed size, budget.' },
        { title: 'Every brand you carry', text: 'One search across all your brands and supplier catalogs.' },
        { title: 'Near misses labelled', text: 'A piece that is $49 over budget or 4 inches too wide says so.' },
        { title: 'Shared live to the customer’s portal', text: 'The options appear on the customer’s screen while they are in the store.' },
        { title: 'They leave with it', text: 'The portal stays on their phone, in sync with your screen, with a line to your store.' },
        { title: 'Build a package', text: 'Pieces, your price, the total, good for 14 days. One tap to send.' },
      ]}
      customer={{
        title: 'What your customer gets',
        items: [
          { title: 'Their own portal', text: 'Every piece that fit, the sizes, and your price, on their phone.' },
          { title: 'Time to decide', text: 'They keep browsing at home and the portal keeps up.' },
          { title: 'A person on the other end', text: 'Their questions go to your salesperson, not to a bot.' },
        ],
      }}
      steps={[
        { title: 'We load every brand', text: 'Prices, dimensions, colours, and stock from your supplier feeds.' },
        { title: 'Your team signs in', text: 'On a tablet or a phone, with your store account.' },
        { title: 'First walk-in, first match', text: 'One store started using it on its own before we had finished setting up the rest.' },
      ]}
      faqs={FAQS}
      closing={{ title: 'See it match a customer.', text: 'Bring a real customer request to the demo.' }}
    />
  );
}
